import makeDebug from 'debug'
import { ProductTypeE } from '@/scripts/constants/plp'

const debug = makeDebug('plp:banners')
import head from 'lodash/head'
export const getBannersFromPage = () => {
  const bannersInPage = [...document.querySelectorAll('[data-plp-banner]')]
  const filteredBanners = bannersInPage.filter(
    (banner) => banner.innerHTML && banner.innerHTML !== '\n'
  )
  return filteredBanners
}

export const mapProducts = (products = []) => {
  return products.map((product) => {
    return {
      type: ProductTypeE.PRODUCT,
      size: 1,
      product,
    }
  })
}

export const mapBanners = (rawBanners = []) => {
  const result = rawBanners
    .map((node) => {
      return {
        position: Number(node.dataset.bannerPosition) - 1,
        size: Number(node.dataset.bannerSize),
        template: node.innerHTML,
        visibleOnFilter: node.dataset.bannerVisibleOnFilter,
        type: ProductTypeE.BANNER,
      }
    })
    .sort(sortBanners)

  debug('Sorted banners %o', result)
  return result
}

export const generateProductsAndBanners = ({ products = [], banners = [], numberOfColumns }) => {
  banners = normalizeSizeOfBanners(banners, numberOfColumns)

  if (numberOfColumns <= 0) {
    return []
  }

  if (products.length === 0) {
    return [...banners]
  }

  if (banners.length === 0) {
    return [...products]
  }

  const bannersBuffer = []

  let actualIndexOfDisplayedTiles = 0

  const result = []

  const resultLenght = products.length + banners.length
  for (let i = 0; i < resultLenght; i++) {
    if (bannersBuffer.length > 0) {
      const firstBannerInsideBuffer = head(bannersBuffer)
      if (
        isPossibleToPushBanner({
          banner: firstBannerInsideBuffer,
          index: actualIndexOfDisplayedTiles,
          numberOfColumns,
        })
      ) {
        bannersBuffer.shift()
        result.push(firstBannerInsideBuffer)
        actualIndexOfDisplayedTiles += firstBannerInsideBuffer.size
        continue
      }
    }

    const iterationBanner = getBannerAtPosition(banners, actualIndexOfDisplayedTiles)
    if (iterationBanner) {
      if (
        isPossibleToPushBannerAtHisOwnPosition({
          banner: iterationBanner,
          index: actualIndexOfDisplayedTiles,
          numberOfColumns,
        })
      ) {
        banners.shift()
        result.push(iterationBanner)
        actualIndexOfDisplayedTiles += iterationBanner.size
        continue
      }

      bannersBuffer.push(iterationBanner)
      banners.shift()
    }

    const currentProduct = head(products)
    if (currentProduct) {
      products.shift()
      result.push(currentProduct)
      actualIndexOfDisplayedTiles++
    }
  }

  return [...result, ...bannersBuffer, ...banners]
}

export const getBannerAtPosition = (banners = [], position) => {
  return banners.find((banner) => banner.position === position)
}

export const isPossibleToPushBanner = ({ banner, index, numberOfColumns }) => {
  const numberOfColumnsAvailable = numberOfColumns - (index % numberOfColumns)

  return numberOfColumnsAvailable >= banner.size
}

export const isPossibleToPushBannerAtHisOwnPosition = ({ banner, index, numberOfColumns }) => {
  const numberOfColumnsAvailable = numberOfColumns - (index % numberOfColumns)

  if (banner.position === index) {
    return numberOfColumnsAvailable >= banner.size
  }

  return false
}

export const sortBanners = (a, b) => a.position - b.position

// TODO: check if this is still needed
export const getBannerAtPositionFromDynamic = (dynamicBanners, position) => {
  return dynamicBanners[position] ? dynamicBanners[position] : ''
}

export const normalizeSizeOfBanners = (dynamicBanners, numberOfColumns) => {
  const normalizedBannersBySize = dynamicBanners.map((banner) => {
    if (banner.size > numberOfColumns) {
      banner.size = numberOfColumns
    }
    return banner
  })

  return normalizedBannersBySize
}
